import { memo } from "react";
import Box from "@mui/material/Box";
import { useSortable } from "@dnd-kit/sortable";

import type { SectionDragHandleProps } from "../types";

export interface ClinicalCrmSortableSectionCardProps {
  id: string;
  children: (params: { dragHandleProps: SectionDragHandleProps }) => React.ReactNode;
}

const ClinicalCrmSortableSectionCard = memo(
  ({ id, children }: ClinicalCrmSortableSectionCardProps) => {
    const { setNodeRef, transform, transition, attributes, listeners } =
      useSortable({ id });

    const transformStyle = transform
      ? `translate3d(0px, ${transform.y}px, 0px)`
      : undefined;

    return (
      <Box ref={setNodeRef} sx={{ transform: transformStyle, transition }}>
        {children({
          dragHandleProps: {
            attributes: attributes as object,
            listeners: (listeners ?? {}) as object,
          },
        })}
      </Box>
    );
  },
);

ClinicalCrmSortableSectionCard.displayName = "ClinicalCrmSortableSectionCard";

export default ClinicalCrmSortableSectionCard;
